function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Grow";
// Limitless imports
import TimePosted from "../../time-posted/TimePosted";
import FadeUp from "../../animation/fade-up/FadeUp";
import { withi18n } from "../../hocs/i18n";
class CustomerDialogueWrapper extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      animate: this.props.dialogue.created ? false : true,
      animating: this.props.dialogue.created ? false : true,
      animationComplete: false,
      animationExited: false
    });
    _defineProperty(this, "handleAnimationCompleted", () => {
      const newState = {
        animating: false
      };
      if (this.props.dialogue.created) {
        newState.animationComplete = true;
      }
      this.setState(newState);
    });
    _defineProperty(this, "handleAnimationExit", () => {
      this.setState({
        animationExited: true
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.dialogue.created && !this.state.animating) {
      this.setState({
        animationComplete: true
      });
    }
    if (nextProps.dialogue.created && !this.props.shouldAnimate) {
      this.setState({
        animationExited: true,
        animate: false
      });
    }
  }
  render() {
    const {
      created
    } = this.props.dialogue;
    const {
      t,
      classes,
      shouldAnimate,
      children
    } = this.props;
    const {
      animate,
      animationComplete,
      animationExited
    } = this.state;
    return /*#__PURE__*/React.createElement(FadeUp, {
      shouldAnimate: shouldAnimate
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.responseListContainer
    }, children(classes), /*#__PURE__*/React.createElement("div", {
      className: classes.responseTime
    }, (!animate || animationExited) && /*#__PURE__*/React.createElement(TimePosted, {
      time: created
    }), animate && /*#__PURE__*/React.createElement(Fade, {
      in: !animationComplete ? true : false,
      timeout: {
        enter: 1000,
        exit: 800
      },
      onEntered: this.handleAnimationCompleted,
      onExited: this.handleAnimationExit,
      appear: shouldAnimate,
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      classes: {
        caption: classes.caption
      }
    }, t("Sending..."))))));
  }
}
const styles = ({
  palette,
  typography
}) => {
  var _palette$dialogues$cu, _palette$dialogues, _palette$dialogues$cu2, _palette$dialogues$cu3, _palette$dialogues2, _palette$dialogues2$c, _palette$dialogues$cu4, _palette$dialogues3, _palette$dialogues3$c;
  return {
    responseListContainer: {
      paddingTop: 10,
      paddingBottom: 10
    },
    dialogueWrapper: {
      display: "flex"
    },
    responseTime: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: 5,
      paddingTop: 5
    },
    caption: {
      color: palette.contrast.text
    },
    customerBackground: {
      backgroundColor: (_palette$dialogues$cu = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$cu2 = _palette$dialogues.customer) === null || _palette$dialogues$cu2 === void 0 ? void 0 : _palette$dialogues$cu2.background) !== null && _palette$dialogues$cu !== void 0 ? _palette$dialogues$cu : palette.primary.light
    },
    customerText: {
      color: (_palette$dialogues$cu3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$c = _palette$dialogues2.customer) === null || _palette$dialogues2$c === void 0 ? void 0 : _palette$dialogues2$c.text) !== null && _palette$dialogues$cu3 !== void 0 ? _palette$dialogues$cu3 : palette.primary.dark,
      fontFamily: (_palette$dialogues$cu4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$c = _palette$dialogues3.customer) === null || _palette$dialogues3$c === void 0 ? void 0 : _palette$dialogues3$c.fontFamily) !== null && _palette$dialogues$cu4 !== void 0 ? _palette$dialogues$cu4 : typography.fontFamily
    }
  };
};
export default withStyles(styles)(withi18n(CustomerDialogueWrapper));
CustomerDialogueWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  dialogue: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired
};